import { render } from "./Home-index.vue?vue&type=template&id=4edfc154&scoped=true"
import script from "./Home-index.vue?vue&type=script&lang=js"
export * from "./Home-index.vue?vue&type=script&lang=js"

import "./Home-index.vue?vue&type=style&index=0&id=4edfc154&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edfc154"]])

export default __exports__